import React, { useEffect, useState } from 'react'
import { structureTicketObj } from '../../../../../Utils'
import { TicketsButton } from './ticketSelector/TicketsButton'
import { EventGQL } from '../../../../../Api'
import { createTicketUTM } from '../../../../../Routing'
import { TixActionCon } from './actionStyles'
type ActionsParams = {
  week: string
  events: EventGQL[]
  location?: string
}

type TicketsType = {
  weekend: string
  suiteId: string
  waitList: boolean
  dayTickets: DayTicketsType[]
}

type DayTicketsType = {
  date: string
  ticketUrl: string
  ticketId: string
}

export const HeaderActions: React.FC<React.PropsWithChildren<ActionsParams>> = ({
  week,
  events,
  location = 'Schedule',
}) => {
  const [tickets, setTickets] = useState<TicketsType>()

  useEffect(() => {
    if (events.length > 0) {
      const tix = structureTicketObj(week, events, location)
      setTickets(tix)
    }
  }, [events])

  const setWeekendUrl = () => {
    if (events[0]?.weekendTicketId) {
      return createTicketUTM({
        ticketId: events[0].weekendTicketId,
        location,
      })
    }
    return
  }

  return (
    <TixActionCon>
      {tickets && (
        <div className="tickets">
          <TicketsButton
            event={events[0]}
            week={events[0].week}
            weekendUrl={setWeekendUrl()}
            waitList={tickets.waitList}
            dayTickets={tickets.dayTickets}
            market={events[0].location}
          />
        </div>
      )}
    </TixActionCon>
  )
}
